export default "__VITE_ASSET__9gzZninG__"